import debounce from 'lodash/debounce';
import difference from 'lodash/difference';
import { fuzzySearch } from 'lib/fuzzy_search';

// ---------------------------------------------------------------------------
// Módulo Search
// ---------------------------------------------------------------------------

export default {
  bindSearch() {
    this.search = debounce(this._search.bind(this), 250);
  },

  _staticSearch(text) {
    const $labels = $('.dropdown-menu li label', this.$component);

    if (text.length) {
      $labels.each((i, el) => {
        const $label = $(el);
        const $parent = $label.parent('li');
        const labelText = this.removeAccents($label.text().toLowerCase());

        if (labelText.indexOf(text) > -1) {
          $parent.show();
        } else {
          $parent.hide();
        }
      });
    } else {
      $('.dropdown-menu li', this.$component).show();
    }
  },

  _fuzzySearch(rawText) {
    rawText = rawText.trim();

    this.renderedValues = [];
    this.isSearch = true;
    this.currentPage = 1;

    if (!rawText.length) {
      this.isSearch = false;
      const data = this._getPage(1).data;
      this.isSearch = true;

      if (difference(data, this._getOptions()).length) {
        this.isSearch = false;
        this.renderOptions(data, true, false);
      }

      return;
    }

    const textField = this.textField;
    this.filteredOptions = fuzzySearch(
      this.options,
      rawText,
      opt => (textField ? opt[textField] : null) || opt.toString()
    );

    this.renderOptions(this._getPage(1).data, true, false);
  },

  _arraySearch(text) {
    text = text.trim();
    const options = this.options;

    this.renderedValues = [];
    this.isSearch = true;
    this.currentPage = 1;

    if (text.length) {
      this.filteredOptions = options.filter(option => {
        let optionText = option[this.textField] || option.toString();
        optionText = this.removeAccents(optionText.trim().toLowerCase());

        return optionText.indexOf(text) > -1;
      });

      this.renderOptions(this._getPage(1).data, true, false);
    } else {
      this.isSearch = false;
      const data = this._getPage(1).data;
      this.isSearch = true;

      if (difference(data, this._getOptions()).length) {
        this.isSearch = false;
        this.renderOptions(data, true, false);
      }
    }
  },

  _search() {
    const rawValue = $('.q-search-input input', this.$component).val();

    if (this.ajax) {
      if (this.config.fuzzySearch) {
        this._fuzzySearch(rawValue);
      } else {
        const text = this.removeAccents(rawValue.toLowerCase());
        this._arraySearch(text);
      }
    } else {
      const text = this.removeAccents(rawValue.toLowerCase());
      this._staticSearch(text);
    }
  },

  _bindSearchEvents() {
    if (!this.config.search) {
      return;
    }

    const self = this;
    const $input = $('.q-search-input input', self.$component);

    $input.keydown(function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        return false;
      } else {
        self.search();
      }
    });

    $('.q-search-input .q-clear-btn', this.$component).on('click', function () {
      $input.val('').trigger('change');
      self.search();
    });
  }
};
